module.exports = __webpack_public_path__ + "static/media/student-summary-lose.27b8e981.png";